import { FC } from 'react';
import './ClassicButton.css';
import MyLoader from '../MyLoader/MyLoader';

interface ClassicButtonProps {
    isLoading?: boolean;
    width?: string;
    height?: string;
    padding?: string;
    bgColor?: string;
    fontColor?: string;
    border?: string;
    borderRadius?: string;
    innerLoaderSize?: string;
    innerLoaderColor?: string;
    isHovering?: boolean;
    fontSize?: string;
    fontFamily?: string;
    children?: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const ClassicButton: FC<ClassicButtonProps> = ({ 
    isLoading, 
    width, 
    height, 
    padding, 
    bgColor, 
    fontColor, 
    borderRadius, 
    innerLoaderSize,
    innerLoaderColor,
    border, 
    onClick,
    children,
    isHovering,
    fontSize,
    fontFamily
}) => {
    
    const styles = {
        ...(width && { width: `${width}` }),
        ...(height && { height: `${height}` }),
        ...(padding && { padding: `${padding}` }),
        ...(bgColor && { backgroundColor: `${bgColor}` }),
        ...(fontColor && { color: `${fontColor}` }),
        ...(borderRadius && { borderRadius: `${borderRadius}` }),
        ...(border && { border: `${border}` }),
        ...(fontSize && { fontSize: `${fontSize}` }),
        ...(fontFamily && { fontFamily: `${fontFamily}` }),
    };
    
    return (
        <button 
            className={`classicButton ${isHovering ? 'hover' : ''}`}
            style={styles} 
            onClick={onClick}
            disabled={isLoading}
        >
            {isLoading ? 
                <MyLoader 
                    size={innerLoaderSize ?? ''} 
                    color={innerLoaderColor ?? ''}
                /> : children}
        </button>
    );
};

export default ClassicButton;
